export const MENU_ITEMS: any = [
  {
     name: "Home",
     link: "/admin/dashboard",
     font: "fa-home",
     active: false, show: true,
     children: [

     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "Functions",
     link: "#",
     font: "fa-table",
     active: false, show: true,
     children: [
        {
           name: "Company",
           link: "#",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [
              {
                 name: "Department & Roles",
                 link: "/admin/departments",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Roles Hierarchy",
                 link: "/admin/role-hierarchy",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              }
           ],
           subfont: "fa-angle-down pull-right"
        },
        {
           name: "Commerce",
           link: "#",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [
              {
                 name: "Currency",
                 link: "/admin/currency",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Product",
                 link: "/admin/product",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Clientele Industry",
                 link: "/admin/industries",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              }
           ],
           subfont: "fa-angle-down pull-right"
        },
        {
           name: "Operations",
           link: "#",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [
              {
                 name: "Holiday Calendar",
                 link: "/admin/calendar",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Country & State",
                 link: "/admin/country",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Locations",
                 link: "#",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [
                    {
                       name: "Office Locations",
                       link: "/admin/location",
                       font: "fa-circle-o",
                       active: false, show: true,
                       locchild: [

                       ]
                    },
                    {
                       name: "Business Locations",
                       link: "/admin/business-location",
                       font: "fa-circle-o",
                       active: false,
                       show: true,
                       locchild: [

                       ]
                    }
                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Teams",
                 link: "/admin/teams",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Persona",
                 link: "#",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [
                    {
                       name: "Buyer Persona",
                       link: "/admin/buyer",
                       font: "fa-circle-o",
                       active: false, show: true,
                       locchild: [

                       ]
                    },
                    {
                       name: "Executive Persona",
                       link: "/admin/executive",
                       font: "fa-circle-o",
                       active: false, show: true,
                       locchild: [

                       ]
                    }
                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Task",
                 link: "/admin/task",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ]
              }
           ],
           subfont: "fa-angle-down pull-right"
        },
        {
           name: "Marketing",
           link: "#",
           font: "fa-circle-o",
           active: false,
           show: true,
           subChildren: [
              {
                 name: "Lead Source",
                 link: "/admin/leadsrc",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              }
           ],
           subfont: "fa-angle-down pull-right"
        }
     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "E-Mail Settings",
     link: "#",
     font: "fa-envelope",
     active: false, show: true,
     children: [
        {
           name: "Admin Mail Settings",
           link: "/admin/mail",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [

           ]
        },
        {
           name: "User Mail Settings",
           link: "/admin/user-email-settings",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [

           ]
        }
     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "Custom Fields",
     link: "/admin/custom-fields",
     font: "fa-table",
     active: false, show: true,
     children: [

     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "Users",
     link: "/admin/users",
     font: "fa-users",
     active: false, show: true,
     children: [

     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "Reporting Tree",
     link: "/admin/reporting-tree",
     font: "fa-sitemap",
     active: false, show: true,
     children: [

     ],
     subfont: "fa-angle-down pull-right"
  },
  {
     name: "Sales",
     link: "#",
     font: "fa-cart-arrow-down",
     active: false, show: true,
     children: [
        {
           name: "Master Cycle",
           link: "/admin/mastercycle",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [

           ],
        },
        {
           name: "Sales Cycle",
           link: "/admin/salescycle",
           font: "fa-circle-o",
           active: false, show: true,
           subChildren: [
              {
                 name: "Sales Cycle",
                 link: "/admin/salescycle",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Sales Cycle Parameter",
                 link: "/admin/sales-cycle-parameter",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Qualifiers",
                 link: "/admin/qualifier",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              },
              {
                 name: "Stage Attributes",
                 link: "/admin/stage-attributes",
                 font: "fa-circle-o",
                 active: false, show: true,
                 locchild: [

                 ],
                 subfont: "fa-angle-down pull-right"
              }
           ],
           subfont: "fa-angle-down pull-right"
        }
     ],
     subfont: "fa-angle-down pull-right"
  },
  // {
  //    name: "Lead Infusion API",
  //    link: "/admin/lead-infusion",
  //    font: "fa-table",
  //    active: false, show: true,
  //    children: [

  //    ],
  //    subfont: "fa-angle-down pull-right"
  // },
  {
     name: "Sales Mill",
     link: "/admin/sales-mill",
     font: "fa-filter",
     active: false, show: true,
     children: [

     ],
     subfont: "fa-angle-down pull-right"
  }
]
